import React, {useState} from 'react';
import SignIn from '../components/signIn'
import {Col} from "antd";
import Dashboard from "../components/Dashboard";

const signInPage = (props) => {
    if(props.history.action=="REPLACE"){
        window.location.reload();
        return
    }
    const SignInForm = () => (
        <Col
            span={12}
            lg={8}
            style={{
                marginBottom: '24px',
            }}
        >
            <SignIn imba_id={props.match.params.imba_id}/>
        </Col>
    )
    return (
        <Dashboard>
            <SignInForm/>
        </Dashboard>
    )
};

export default signInPage;